import { injectable } from 'inversify';

import { Failure, OperationResult, Success } from '@vp/common/core/OperationResult';
import { AccessManagerRepository } from '@vp/manager/access/core/interface/AccessManagerRepository';
import { ProfileManagerState } from '@vp/manager/profile/core/interface/ProfileManagerState';
import { ProfileAccessModel } from '@vp/profile/core/model/ProfileAccessModel';

@injectable()
export class ApplyChangesUsecase {
  constructor(
    private readonly repository: AccessManagerRepository,
    private readonly state: ProfileManagerState,
  ) {}

  async execute(changes: ProfileAccessModel, controller?: AbortController): Promise<OperationResult> {
    const profileId = this.state.active.value?.id;
    if (!profileId) return Failure.from('Профиль не выбаран.');

    const result = await this.repository.apply(profileId, changes, controller);

    if (result instanceof Success) {
      this.state.updateAccess(result.value);
    }

    return result as OperationResult;
  }
}
